import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { NavBar } from "./components/NavBar";
import { Banner } from "./components/Banner";
import { Idea } from "./components/Idea";
import { Testmonials } from "./components/Testmonials";
import { Projects } from "./components/Projects";
import { Portfolio } from "./components/Portfolio";
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";


function App() {
  return (
    <div className="App">
      <NavBar />
      <Banner />
      <Idea />
      
      <Portfolio />
      <Testmonials />
      <Contact />
      
      <Footer />
    </div>
  );
}

export default App;
